import http from './http'
import createCatalogService from './catalogService'

export default {
  ...createCatalogService('/Telas/ContaBancaria'),
  async getOwnerOptions () {
    const response = await http.get('/Telas/ContaBancaria/GetOwnerOptions')
    return response.data
  }
}
